const LOCK_NAME = 'auth-refresh'


/**
 * Runs the given work with no other tab of this origin running it at the same
 * time.
 *
 * A browser without the Web Locks API runs the work straight away, which is
 * what every browser did before.
 *
 * @param {Function} callback - the work to serialize
 *
 * @returns {Promise} resolves or rejects with whatever the work did
 */
export default function withCrossTabLock(callback) {
  if ( !navigator.locks ) {
    return callback()
  }

  return navigator.locks.request(LOCK_NAME, callback)
}
